export const PER_PAGE_PROPERTY_STATUS = 'PER_PAGE_PROPERTY_STATUS';
export const PAGE_PROPERTY_STATUS = 'PAGE_PROPERTY_STATUS';
export const SEARCH_PROPERTY_STATUS = 'SEARCH_PROPERTY_STATUS';
export const PAGES_PROPERTY_STATUS = 'PAGES_PROPERTY_STATUS';
export const ARRAY_LIST_PROPERTY_STATUS = 'ARRAY_LIST_PROPERTY_STATUS';
export const ARRAY_LIST_TO_DROPDOWN_PROPERTY_STATUS = 'ARRAY_LIST_TO_DROPDOWN_PROPERTY_STATUS';
export const REFRESH_TABLE_PROPERTY_STATUS = 'REFRESH_TABLE_PROPERTY_STATUS';
export const IS_OPEN_MODAL_PROPERTY_STATUS = 'IS_OPEN_MODAL_PROPERTY_STATUS';
export const IS_LOADING_SHOW_PROPERTY_STATUS = 'IS_LOADING_SHOW_PROPERTY_STATUS';
export const IS_LOADING_FORM_PROPERTY_STATUS = 'IS_LOADING_FORM_PROPERTY_STATUS';
export const FORM_TYPE_PROPERTY_STATUS = 'FORM_TYPE_PROPERTY_STATUS';
export const FORM_DATA_PROPERTY_STATUS = 'FORM_DATA_PROPERTY_STATUS';
